// tslint:disable-next-line
var has = require('@dojo/core/has');

if (!has.exists('build-time-render')) {
	has.add('build-time-render', false, false);
}



// WEBPACK FOOTER //
// hasBuildTimeRender.ts